import Vue from "vue";
import Vuex from "vuex";

import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
import { auth } from "./auth/auth.module";
import chatter from "./chatter/chatter.module";
import requirement from "./chatter/requirement.module";
import ghg from "./esg/ghg.module";
import report from "./esg/report.module"


//2023-08-25 My schedule//
import mySchedule from "./chatter/mySchedule.module";
import project from "./chatter/project.module";

// 2023-10-12 Chatter Files
import chatterFiles from "./chatter/chatterFiles.module";

// 22023-12-12 Chatter WBS
import wbs from "./chatter/wbs.module";

// 24-03-15 Board
import board from "./board/board.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth, chatter, ghg, report, mySchedule, project, chatterFiles, wbs, board, requirement
  },
  state: {
    message: null, // global message

    deviceIds: [], // retrieveDeviceList 의 결과 중 ID들만
    peonList: [], // List의 요소는 Peon 정보들의 Map {'tenantId': '', 'deviceId': '', 'alias': '', 'status': '', 'cpu': '', 'memory': '', 'disk': '', 'tick': ''}
    peonList2: [],
    deviceList: [],
    
    selectedGroup: '',
    groupOptions: [
      { value: '', text: '전체' },
    ],
    
    totalUnconfirmedAlarmCount: 0,

    totalUnconfirmedAlarm: 0,
    totalAlarm: 0,
    totalNormalNotification: 0,
    totalNotification: 0,
    notificationList: [],
    notificationMap: {},

    statistics: {}, // 각 Device별 통계
    statisticsSummary: {}, // Device별 통계의 합
    totalRunningTime: "", // 이번 달 전체 bot들의 running time (단위를 포함한 문자열임)
    days: {},

    userList: [],

    scriptList: [],
    recentScriptList: [],
    propertyList: [],

    authorityList: [], //20221102 추가
    kakaoUserList: [], //20230321 카카오 유저 리스트 추가
  },
  getters,
  mutations,
  actions,
});
